// import { easepick } from '@easepick/core';
// import { RangePlugin } from '@easepick/range-plugin';
// import { LockPlugin } from '@easepick/lock-plugin';

/* global easepick, RangePlugin, LockPlugin: false */

const MIN_ADULTS = 2;
const MAX_ADULTS = 10;
const MIN_CHILDREN = 0;
const MAX_CHILDREN = 10;

export default class BookingForm {
	constructor() {
		this.forms = document.querySelectorAll('[data-id="booking-form"]');
		if (!this.forms) return;

		this.init();
	}

	init() {
		this.forms.forEach((form) => {
			const hotelField = form.querySelector('[data-id="hotel-field"]');
			const checkinField = form.querySelector('[data-id="checkin-field"]');
			const checkoutField = form.querySelector('[data-id="checkout-field"]');
			const adultsField = form.querySelector('[data-id="adults-field"]');
			const childrenField = form.querySelector('[data-id="children-field"]');

			const checkinMonthLabel = form.querySelector('[data-id="checkin-month-label"]');
			const checkinDayLabel = form.querySelector('[data-id="checkin-day-label"]');
			const checkoutMonthLabel = form.querySelector('[data-id="checkout-month-label"]');
			const checkoutDayLabel = form.querySelector('[data-id="checkout-day-label"]');

			const startDate = new Date(checkinField.value);
			const endDate = new Date(checkoutField.value);

			const checkinMinDate = new Date(checkinField.getAttribute("min"));

			this.setDayLabel(startDate, checkinDayLabel);
			this.setMonthLabel(startDate, checkinMonthLabel);
			this.setDayLabel(endDate, checkoutDayLabel);
			this.setMonthLabel(endDate, checkoutMonthLabel);

			const adultsIncButton = form.querySelector('[data-id="adults-inc"]');
			const adultsDecButton = form.querySelector('[data-id="adults-dec"]');
			const adultsLabel = form.querySelector('[data-id="adults-num"]');

			const childrenInc = form.querySelector('[data-id="children-inc"]');
			const childrenDec = form.querySelector('[data-id="children-dec"]');
			const childrenLabel = form.querySelector('[data-id="children-num"]');

			hotelField.addEventListener('change', function () {
				const selectedValue = hotelField.value;

				if (selectedValue === 'atriumhotelsrhodes') {
					checkinField.value = '2025-04-11';
				} else if (selectedValue === 'atriumplatinum') {
					checkinField.value = '2025-04-11';
				} else if (selectedValue === 'atriumpalace') {
					checkinField.value = '2025-05-01';
				} else if (selectedValue === 'atriumprestige') {
					checkinField.value = '2025-05-01';
				}

				// Update the labels to reflect the new check-in date
				const newStartDate = new Date(checkinField.value);
				bookingForm.setDayLabel(newStartDate, checkinDayLabel);
				bookingForm.setMonthLabel(newStartDate, checkinMonthLabel);

				// Automatically set the checkout date to 2 days after the check-in date
				const newEndDate = new Date(newStartDate);
				newEndDate.setDate(newStartDate.getDate() + 2);
				checkoutField.value = newEndDate.toISOString().split('T')[0]; // Format the date as YYYY-MM-DD

				// Update the checkout labels as well
				bookingForm.setDayLabel(newEndDate, checkoutDayLabel);
				bookingForm.setMonthLabel(newEndDate, checkoutMonthLabel);
			});

			adultsLabel.innerHTML = adultsField.value;
			childrenLabel.innerHTML = childrenField.value;

			const bookingForm = this;

			const picker = new easepick.create({
				element: checkinField,
				css: [
					THEME_OBJ.template_directory + '/src/css/easepick/easepick-bundle.min.css',
				],
				grid: 2,
				calendars: 2,
				setup(picker) {
					picker.on('select', (event) => {
						const { start, end } = event.detail;
						bookingForm.setDayLabel(start, checkinDayLabel);
						bookingForm.setMonthLabel(start, checkinMonthLabel);
						bookingForm.setDayLabel(end, checkoutDayLabel);
						bookingForm.setMonthLabel(end, checkoutMonthLabel);
					});
				},
				plugins: ['RangePlugin', 'LockPlugin'],
				// plugins: [RangePlugin, LockPlugin],
				RangePlugin: {
					tooltipNumber(num) {
						return num - 1;
					},
					elementEnd: checkoutField,
					locale: {
						one: 'night',
						other: 'nights',
					},
				},
				LockPlugin: {
					minDate: checkinMinDate,
					minDays: 2,
				},
			});

			form.addEventListener('submit', (e) => {
				e.preventDefault();
				const button = e.submitter;
				let domain = '.reserve-online.net/';
				if (button.id === 'hotel-flight') {
					domain = '.hotelwithflight.com/';
				}
				const subdomain = hotelField.value ?? 'marbellacollection';
				const url = `https://${subdomain}${domain}`;

				const checkinDate = checkinField.value;
				const checkoutDate = checkoutField.value;
				const adults = adultsField.value;
				const children = childrenField.value;

				this.submitForm({
					checkinDate,
					checkoutDate,
					adults,
					children,
				}, url);
			});

			if (adultsIncButton) {
				adultsIncButton.addEventListener('click', (e) => {
					this.changeAmount(adultsLabel, adultsField, 'increase', 'adults');
				});
			}

			if (adultsDecButton) {
				adultsDecButton.addEventListener('click', (e) => {
					this.changeAmount(adultsLabel, adultsField, 'decrease', 'adults');
				});
			}

			if (childrenInc) {
				childrenInc.addEventListener('click', (e) => {
					this.changeAmount(childrenLabel, childrenField, 'increase', 'children');
				});
			}

			if (childrenDec) {
				childrenDec.addEventListener('click', (e) => {
					this.changeAmount(childrenLabel, childrenField, 'decrease', 'children');
				});
			}

		});
	}

	changeAmount(label, field, mode = 'increase', type = 'adults') {
		const currentValue = parseInt(
			field.value || 0
		);
		let newValue = 0;

		if (mode === 'increase') {
			newValue = currentValue + 1;
			if (type === 'adults' && newValue > MAX_ADULTS) return;
			if (type === 'children' && newValue > MAX_CHILDREN) return;
		} else if (mode === 'decrease') {
			newValue = currentValue - 1;
			if (type === 'adults' && newValue < MIN_ADULTS) return;
			if (type === 'children' && newValue < MIN_CHILDREN) return;
		}

		field.value = parseInt(newValue);

		label.innerHTML = newValue;
	}

	setMonthLabel(date, label) {
		if (date instanceof Date && !isNaN(date)) {
			label.innerHTML = date.toLocaleString(document.documentElement.lang, {
				month: 'short',
			});
		}
	}

	setDayLabel(date, label) {
		if (date instanceof Date && !isNaN(date)) {
			label.innerHTML = date.getDate();
		}
	}

	submitForm(values, url) {
		window.open(`${url}?checkin=${values.checkinDate}&checkout=${values.checkoutDate}&adults=${values.adults}&children=${values.children}&rooms=1`, '_blank');
	}
};
